// Canvas (e.g. Chart.js) can't read CSS custom properties like `var(--x)` directly - this
// resolves one to its live rgb() value via a hidden probe element, then re-applies the
// caller's own alpha. Since it reads whatever color the active theme currently defines for
// that variable, a new theme just works here too, without any theme-specific branching.
let probeElement: HTMLSpanElement | undefined;

export function cssVarRgba(cssVar: string, alpha: number): string {
  if (!probeElement) {
    probeElement = document.createElement('span');
    probeElement.style.position = 'absolute';
    probeElement.style.visibility = 'hidden';
    probeElement.style.pointerEvents = 'none';
    document.body.appendChild(probeElement);
  }
  probeElement.style.color = `var(${cssVar})`;
  const [r, g, b] = getComputedStyle(probeElement).color.match(/\d+(\.\d+)?/g) ?? ['255', '255', '255'];
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
